<template>
  <v-dialog persistent v-model="showDialog" width="700">
    <v-card :loading="loading">
      <v-form
        lazy-validation
        v-model="form"
        ref="newEngineReleaseForm"
        :disable="loading"
      >
        <v-card-title>
          <span class="text-h6">New Engine Release (New Engine)</span>
          <v-spacer></v-spacer>
          <v-btn @click="close" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-row no-gutters class="mt-0">
            <v-col cols="12">
              <v-text-field
                v-model="payload.name"
                :rules="[rules.required]"
                color="deep-purple"
                label="*Release Version (e.g. 2.5.4)"
                outlined
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-checkbox
                v-model="payload.is_latest"
                label="Set as Latest"
                color="primary"
                hide-details="auto"
              ></v-checkbox>
            </v-col>
          </v-row>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="save()" :disabled="!form || loading" color="primary">
              Save
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import Swal from 'sweetalert2'
import { apiService } from '../../service/api.service'

export default {
  name: 'NewEngineReleaseDialog',
  props: {
    showDialog: { type: Boolean, default: false }
  },
  data: () => ({
    loading: false,
    form: true,
    payload: {
      name: '',
      is_latest: true
    },
    rules: {
      required: (v) => !!v || 'This field is required'
    }
  }),
  methods: {
    close () {
      this.$emit('close')
    },
    async save () {
      if (this.$refs.newEngineReleaseForm.validate()) {
        this.loading = true
        await apiService
          .post('admin/new_engine_releases', this.payload)
          .then(() => {
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: 'New engine release successfully added.'
            })
            this.$emit('added')
            this.close()
          })
          .catch((err) => {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: err?.response?.data?.message || 'Something went wrong'
            })
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
}
</script>
